module.exports = __webpack_public_path__ + "static/media/scan.05a89454.png";